<div class="d-flex flex-column justify-content-center align-items-center modal-product" style="padding:30px 10px;">
    <div class="dialog-title">
        <h2>Kod QR</h2>
        <button mat-icon-button aria-label="close dialog" mat-dialog-close tabindex="-1"
            style="position:absolute; top:0; right:0;">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <mat-dialog-content class="w-100 d-flex flex-column align-items-center">
        <img id="qr-code" [src]="qrCodeImage" alt="">
        <mat-dialog-actions class="d-flex flex-row justify-content-between w-100 p-2">
            <button *ngIf="0" mat-flat-button color="warn" mat-dialog-close class="w-b w-40">Powrót</button>
            <button mat-flat-button color="primary" (click)="downloadQrCode()" class="w-b w-40">Pobierz</button>
        </mat-dialog-actions>
    </mat-dialog-content>
</div>